/**
 * @typedef Tag
 * @property {string} event
 * @property {string} phase
 * @property {string} sub_phase
 * @property {string} selection
 * @property {string} seccion
 * @property {string} step
 * @property {string} foto
 * @property {string} color
 * @property {string} mensaje
 * @property {string} mensaje_servicio
 * @property {string} tipo
 * @property {string} flag
 * @property {string} nombre_mesa
 * @property {string} numero_mesa
 */

import _ from 'lodash';
import TagManager from 'react-gtm-module';

const DATA_LAYER_NAME = 'dataLayer';
const GTMInitialized = true;

/**
 * @param {Tag} dataLayer
 */
export const createTag = (dataLayer) => {
  if (!GTMInitialized) return;
  TagManager.dataLayer({ dataLayerName: DATA_LAYER_NAME, dataLayer });
};

/**
 * @param {object} params
 * @param {any[]} params.controls
 * @param {(control: any) => Tag} params.tagCompositor
 */
export const createTagsForInvalidFormControls = ({ controls, tagCompositor }) => {
  if (!GTMInitialized || !_.isArray(controls) || !_.isFunction(tagCompositor)) return;
  const definedControls = controls.filter(c => !_.isNil(c));
  const normalizedControls = definedControls.map(c => (_.isNil(c.dateTextBox) ? c : c.dateTextBox));
  const invalidNormalizedControls = normalizedControls.filter(c => !c.isControlStateValid);
  invalidNormalizedControls.forEach(c => createTag(tagCompositor(c)));
};
